// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Ryuc","name":"Header_name__t1Zi7","birthday":"Header_birthday__2S2jr","skeleton":"Header_skeleton__VArxO"};